<div class="editBttn">
  <label *ngIf="label" [for]="labelId">
    {{ label }}
  </label>
  <div
    class="position-relative bg-secondary p-2 rounded"
    style="min-height: 36px"
  >
    <ng-container *ngFor="let item of control?.value">
      <span [title]="item.assetId" class="badge bg-primary mr-1">
        {{ item?.assetId }}
      </span>
    </ng-container>
    <button
      *ngIf="!control['readonly'] && editButton"
      type="button"
      class="editButton btn btn-link"
      [ngStyle]="
        control.touched && control.invalid && { 'margin-right': '22px' }
      "
      (click)="edit()"
    >
      Edit
    </button>
    <div [hidden]="true">
      <ng-select
        #select
        [labelForId]="labelId"
        [formControl]="control"
        bindValue="id"
        editButton="editButton"
        (change)="onChange($event)"
      >
      </ng-select>
    </div>
    <div>
      <app-dc-control-validation
        *ngIf="control.touched"
        [status]="control.invalid | getValidationStatus: showTicksIfValid"
        class="{{
          control.hasError('required') && control.touched ? 'required' : ''
        }}"
        body="{{
          customErrorMessage ? customErrorMessage + '.' + '<br/>' : ''
        }}{{
          control.hasError('required') ? 'Required field' + '.' + '<br/>' : ''
        }}{{
          control.hasError('incorrect') ? control.errors.message + '.' : ''
        }}"
      ></app-dc-control-validation>
    </div>
  </div>
</div>
